export const INVOICE_TEMPLATES = [
  {
    key: "gutachten",
    label: "Gerichtsgutachten",
    referenceLabel: "Aktenzeichen",
    referencePlaceholder: "z.B. 4 O 51/24",
    vatRate: 19,
    note: "Bei Rückfragen stehe ich selbstverständlich gerne zur Verfügung. Vielen Dank für die Zusammenarbeit!",
    items: [
      { description: "Aktenstudium und vorbereitende Arbeiten (Std.)", quantity: "", unit_price: 131 },
      { description: "Auswertung von Untersuchungen wie Röntgen (Std.)", quantity: "", unit_price: 131 },
      { description: "Beurteilung und Beantwortung der Beweisfragen (Std.)", quantity: "", unit_price: 131 },
      { description: "Abfassung des schriftlichen Gutachtens (Std.)", quantity: "", unit_price: 131 },
      { description: "Diktat und Durchsicht der Reinschrift (Std.)", quantity: "", unit_price: 131 },
      { description: "Schreibgebühr (Seiten)", quantity: "", unit_price: 4.5 },
      { description: "Versandkosten (pauschal)", quantity: 1, unit_price: 6 },
    ],
    extras: [
      { key: "untersuchung", label: "Untersuchung", item: { description: "Körperliche Untersuchung des Probanden (Std.)", quantity: "", unit_price: 131 } },
      { key: "termin", label: "Gerichtstermin", item: { description: "Teilnahme am Gerichtstermin (Std.)", quantity: "", unit_price: 131 } },
      { key: "reisezeit", label: "Reisezeit", item: { description: "Reise- und Wartezeit (Std.)", quantity: "", unit_price: 131 } },
      { key: "km", label: "Fahrtkosten Pkw", item: { description: "Fahrtkosten Pkw (km)", quantity: "", unit_price: 0.42 } },
      { key: "fotos", label: "Fotos", item: { description: "Lichtbilder / Fotos (Stück)", quantity: "", unit_price: 2 } },
      { key: "kopien", label: "Kopien", item: { description: "Kopien / Ausdrucke (Seiten)", quantity: "", unit_price: 0.5 } },
      { key: "porto", label: "Porto / Telefon", item: { description: "Porto und Telekommunikation (lt. Beleg)", quantity: 1, unit_price: "" } },
    ],
  },
  {
    key: "fortbildung",
    label: "Reiseabrechnung mit Vortrag",
    referenceLabel: "Veranstaltung",
    referencePlaceholder: "z.B. Grundlagenkurs SKT Zertifikat (Kurs B)",
    vatRate: 0,
    note: "Dieser Rechnungsbetrag ist gemäß § 4 Nr. 21 b, lit. bb) UStG umsatzsteuerfrei.",
    items: [
      { description: "Instruktortätigkeit / Vortrag (Tage)", quantity: 2, unit_price: 550 },
      { description: "Fahrtkosten Hinfahrt (Ticket)", quantity: 1, unit_price: 0 },
      { description: "Fahrtkosten Rückfahrt (Ticket)", quantity: 1, unit_price: 0 },
      { description: "Taxikosten (Fahrt)", quantity: 1, unit_price: 0 },
    ],
    extras: [
      { key: "hotel", label: "Hotelkosten", item: { description: "Hotel / Übernachtung (Nächte)", quantity: 1, unit_price: 0 } },
      { key: "pkw", label: "Fahrtkosten Pkw", item: { description: "Fahrtkosten Pkw (km)", quantity: "", unit_price: 0.3 } },
      { key: "parken", label: "Parkgebühren", item: { description: "Parkgebühren (lt. Beleg)", quantity: 1, unit_price: "" } },
      { key: "verpflegung", label: "Verpflegungspauschale", item: { description: "Verpflegungsmehraufwand (Tage)", quantity: "", unit_price: 14 } },
      { key: "material", label: "Kursmaterial", item: { description: "Kursunterlagen / Material", quantity: 1, unit_price: "" } },
    ],
  },
];
